import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Button from 'v3/components/Button';
import Modal from 'v3/components/Modal';
import Text from 'v3/components/Text';

export default function ConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  setFrontImageCnh,
}) {

  const handleClose = () => {
    setFrontImageCnh([]);
    onClose();
  }

  return (
    <Modal
      show={isOpen}
      handleClose={handleClose}
      heading={
        <Text color="dark" type="header" weight="500">
          Atualizar Implemento
        </Text>
      }
      body={
        <Text color="dark" type="header" fontSize="15px" weight="300">
          Esse implemento já possui dados cadastrados, ao continuar irá atualizar os dados existentes, deseja continuar?
        </Text>
      }
      footer={
        <Row>
          <Col>
            <Button variant="secondary" onClick={handleClose}>
              <Text type="regular" weight="600">
                Cancelar
              </Text>
            </Button>
          </Col>
          <Col>
            <Button variant="success" onClick={onConfirm}>
              <Text type="regular" weight="600">
                Prosseguir
              </Text>
            </Button>
          </Col>
        </Row>
      }
    />
  );
}
